module.exports = __webpack_public_path__ + "img/active2.3cbf5380.png";